// components/TableSummary.js
import {Table} from "antd";
import {memo, useMemo} from "react";

export const TableSummary = memo(({pageData}) => {
    const totals = useMemo(() => {
        let totalDebt = 0;
        let paidCount = 0;
        let debtCount = 0;

        pageData.forEach(({balance}) => {
            const numBalance = parseFloat(balance) || 0;
            if (numBalance < 0) {
                totalDebt += Math.abs(numBalance);
                debtCount++;
            } else {
                paidCount++;
            }
        });

        return {totalDebt, paidCount, debtCount};
    }, [pageData]);

    return (
        <Table.Summary fixed>
            <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={2}>
                    <span style={{fontSize: '13px', fontWeight: 500, color: '#262626'}}>
                        Итого
                    </span>
                </Table.Summary.Cell>

                <Table.Summary.Cell index={2}>
                    <div style={{fontSize: '11px', color: '#8c8c8c', marginLeft: '4px', textAlign: 'center'}}>
                        задолженность
                    </div>
                    <div style={{
                        fontSize: '14px',
                        fontWeight: 600,
                        color: totals.totalDebt > 0 ? '#cf1322' : '#8c8c8c',
                        fontFamily: 'monospace',
                        textAlign: 'center'
                    }}>
                        €{totals.totalDebt.toFixed(2)}
                    </div>
                </Table.Summary.Cell>

                <Table.Summary.Cell index={3} colSpan={2}>
                    <div>
                        <span style={{color: '#389e0d', fontWeight: 500}}>{totals.paidCount}</span>
                        <span style={{color: '#8c8c8c', margin: '0 12px 0 4px', fontSize: '12px'}}>
                        оплачено
                    </span>
                    </div>
                    <div>
                        <span style={{color: '#cf1322', fontWeight: 500}}>{totals.debtCount}</span>
                        <span style={{color: '#8c8c8c', marginLeft: '4px', fontSize: '12px'}}>
                        задолженность
                    </span>
                    </div>

                </Table.Summary.Cell>

                <Table.Summary.Cell index={5}>
                    <span style={{fontSize: '13px', color: '#8c8c8c'}}>всего:</span>
                    <span style={{
                        fontSize: '14px',
                        fontWeight: 500,
                        color: '#262626',
                        marginLeft: '6px'
                    }}>
                        {pageData.length}
                    </span>
                </Table.Summary.Cell>
            </Table.Summary.Row>
        </Table.Summary>
    );
});

TableSummary.displayName = 'TableSummary';